<app-dialog-header [title]="title"></app-dialog-header>
<mat-dialog-content>
  <div class="flex flex-grow">
    <app-numeric-input [label]="'general.api_refund_ticket_range_start'" [(value)]="ticketRangeStart" [required]="true"></app-numeric-input>
    <app-numeric-input [label]="'general.api_refund_ticket_range_end'" [(value)]="ticketRangeEnd" [disabled]="!ticketRangeStart"></app-numeric-input>
  </div>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="refundDialogButtons"></app-dialog-footer>
<ng-template #refundDialogButtons>
  <button mat-button mat-dialog-close>{{'general.api_general_cancel' | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="!exchange || authService.hasRefundExchangePrivilege" [disabled]="!checkTicketRange"
          (click)="addTicketRange()">{{(exchange ? 'general.api_cart_start_refund_exchange' : 'general.api_cart_start_refund') | translate}}</button>
</ng-template>
